/*
 * Project: xpenser-client
 * FilePath: /src/app/components/private-route/index.tsx
 * File: index.tsx
 * Created Date: Saturday, August 29th 2020, 6:41:58 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Sep 18 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 * <<licensetext>>
 */

import React, { useContext } from 'react'
import { Redirect, Route } from 'react-router-dom'

import { Context as AuthContext } from '@components/auth'

interface IPrivateRoute {
  component: React.ComponentType;
  path: string;
}

const PrivateRoute: React.FC<IPrivateRoute> = ({ component: Component, ...rest }) => {
  const { isAuthenticated } = useContext(AuthContext)
  if (isAuthenticated === null) {
    return (<p>Loading...</p>)
  }
  return (
    <Route
      {...rest}
      render={
        ({
          history,
          location,
          match,
          staticContext,
          ...props
        }) => (
          isAuthenticated
            ? <Component {...props} />
            : <Redirect
                to={{
                  pathname: '/login',
                  state: {
                    from: location
                  }
                }}
              />
        )
      }
    />
  )
}

export default PrivateRoute
